import(/* webpackMode: "eager" */ "/app/app/articles/fun-dives-vs-certification-dives-choosing-the-right-scuba-experience-for-your-next-adventure/page.tsx");
